import { render, staticRenderFns } from "./metric-discussions.vue?vue&type=template&id=e0051058&scoped=true"
import script from "./metric-discussions.vue?vue&type=script&lang=js"
export * from "./metric-discussions.vue?vue&type=script&lang=js"
import style0 from "./metric-discussions.vue?vue&type=style&index=0&id=e0051058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0051058",
  null
  
)

export default component.exports